import React, { useState, useEffect } from 'react';
import axios from 'axios'
import { Link, useParams } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, FormGroup, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';

import { storage } from '../../firebase/config'

//Import Icons
import FeatherIcon from 'feather-icons-react';

import tvinsurelogo from '../../shared/images/TV-Insure-Logo-04.png';
import tvinsurebg from '../../shared/images/TVinsure-Contact-Me.png';
import finGroupLine from '../../shared/images/DT06052564.jpg';

import './PageAuth.css';

const PageSignupWithOutCode = () => {

    const remarkid = useParams().remarkid;

    // Normal state for get data
    const [isLoading, setIsLoading] = useState(false);
    const [responseData, setResponseData] = useState();
    const [provinceData, setProvinceData] = useState();
    const [districtData, setDistrictData] = useState();
    const [districtSubData, setDistrictSubData] = useState();
    const [districtSubFilter, setDistrictSubFilter] = useState();
    const [error, setError] = useState(null);

    //contain all form data
    const [formData, setFormData] = useState({
        agentCode: "",
        agentCheck: "uncheck",
        fname: "",
        lname: "",
        idcard: "",
        idcardfileurl: "",
        idcardfileurlloadfinish: "unselect",
        address: "",
        province: "",
        provinceid: "",
        district: "",
        districtid: "",
        districtSub: "",
        nonlifeinsidcard: "",
        brokerlicensefileurl: "",
        brokerlicensefileurlloadfinish: "unselect",
        tel: "",
        email: "",
        password: "",
        repassword: "",
        bookBankNum: "",
        bookbankfileurl: "",
        bookbankfileurlloadfinish: "unselect",
        bankName: "",
        bankBranch: "",
        remark: remarkid
    });

    useEffect(() => {
        const sendProvinceRequest = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get('https://webservice.tvinsure.com/api/masters/province', {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                setProvinceData(response.data)
                setIsLoading(false);
            } catch (err) {
                setError(err.message || 'Something went wrong with Province API, please try again.');
                setIsLoading(false);
            }
        }
        sendProvinceRequest()
        const sendDistrictSubRequest = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get('https://webservice.tvinsure.com/api/masters/districtSub', {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                setDistrictSubData(response.data)
                setIsLoading(false);
            } catch (err) {
                setError(err.message || 'Something went wrong with Province API, please try again.');
                setIsLoading(false);
            }
        }
        sendDistrictSubRequest()
    }, []);

    //listen to all key stroke of formdata
    const handleChange = event => {
        const { name, value } = event.target
        //province must have value
        if (name === "province" && value) {
            const provinceCode = provinceData.filter(p => p.PROV_NAME_T === value)[0].PROVINCE_CODE
            setFormData(prevValue => {
                return {
                    ...prevValue,
                    province: value,
                    provinceid: provinceCode,
                    district: "",
                    districtid: "",
                    districtSub: "",
                    districtSubid: ""
                }
            });
            const sendDistrictRequest = async () => {
                setIsLoading(true);
                try {
                    const response = await axios.post('https://webservice.tvinsure.com/api/masters/district',
                        JSON.stringify({
                            PROVINCE_CODE: provinceCode
                        }),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                    setDistrictData(response.data)
                    setIsLoading(false);
                } catch (err) {
                    setIsLoading(false);
                    setError(err.message || 'Something went wrong with District API, please try again.');
                }
            }
            sendDistrictRequest()
        }

        //district must have value
        if (name === "district" && value) {
            const districtCode = districtData.filter(d => d.DISTRICT_NAME_T === value)[0].DISTRICT_CODE
            const districtSubFilter = districtSubData.filter(ds => ds.DISTRICT_NAME_T === value)
            setFormData(prevValue => {
                return {
                    ...prevValue,
                    district: value,
                    districtid: districtCode,
                    districtSub: "",
                    districtSubid: ""
                }
            });
            setDistrictSubFilter(districtSubFilter)
        }

        //districtSub must have value
        if (name === "districtSub" && value) {
            const districtSubCode = districtSubFilter.filter(ds => ds.DISTRICT_NAME_T_SUB === value)[0].DISTRICT_CODE_SUB
            const zipcode = districtSubData.filter(ds => ds.DISTRICT_CODE_SUB === districtSubCode)[0].ZIPCODE
            setFormData(prevValue => {
                return {
                    ...prevValue,
                    districtSub: value,
                    districtSubid: districtSubCode,
                    zipcode: zipcode
                }
            });
        }

        setFormData(prevValue => {
            return {
                ...prevValue,
                [name]: value
            }
        });
    }

    //Select file function
    const fileSelectedHandler = (event) => {
        const { name, files } = event.target

        const fileMaxSize = 10485760


        if (files[0].size > fileMaxSize) {
            alert("ไฟล์ของคุณมีขนาดเกิน 10 MB กรุณาเลือกไฟล์ใหม่");
            window.location.reload()
        }

        if (files[0].size < fileMaxSize) {
            if (name === "idcardfile") {
                fileIdCardUploadHandler(files[0])
            }

            if (name === "brokerlicensefile") {
                fileBrokerLicenseUploadHandler(files[0])
            }

            if (name === "bookbankfile") {
                fileBookBankUploadHandler(files[0])
            }
        }

        // console.log(name);
        // console.log(files);
    }

    //Upload Id Card File
    const fileIdCardUploadHandler = (file) => {
        const uploadTask = storage.ref(`idcardfile/${file.name}`).put(file);
        uploadTask.on('state_changed',
            snapshot => {
                setFormData(prevValue => {
                    return {
                        ...prevValue,
                        idcardfileurlloadfinish: "uploading"
                    }
                });
            },
            error => {
                setError(error.message)
                setErrorModal(true);
                // console.log(error.message);
            },
            () => {
                storage
                    .ref('idcardfile')
                    .child(file.name)
                    .getDownloadURL()
                    .then(url => {
                        setFormData(prevValue => {
                            return {
                                ...prevValue,
                                idcardfileurl: url,
                                idcardfileurlloadfinish: "uploaded"
                            }
                        });
                        // console.log(url);
                    });
            })
        // console.log(event.target.files);
    }

    //Upload Bookbank File
    const fileBrokerLicenseUploadHandler = (file) => {
        const uploadTask = storage.ref(`brokerlicensefile/${file.name}`).put(file);
        uploadTask.on('state_changed',
            snapshot => {
                setFormData(prevValue => {
                    return {
                        ...prevValue,
                        brokerlicensefileurlloadfinish: "uploading"
                    }
                });
            },
            error => {
                setError(error.message)
                setErrorModal(true);
                // console.log(error.message);
            },
            () => {
                storage
                    .ref('brokerlicensefile')
                    .child(file.name)
                    .getDownloadURL()
                    .then(url => {
                        setFormData(prevValue => {
                            return {
                                ...prevValue,
                                brokerlicensefileurl: url,
                                brokerlicensefileurlloadfinish: "uploaded"
                            }
                        });
                        // console.log(url);
                    });
            })
        // console.log(event.target.files);
    }

    //Upload Bookbank File
    const fileBookBankUploadHandler = (file) => {
        const uploadTask = storage.ref(`bookbankfile/${file.name}`).put(file);
        uploadTask.on('state_changed',
            snapshot => {
                setFormData(prevValue => {
                    return {
                        ...prevValue,
                        bookbankfileurlloadfinish: "uploading"
                    }
                });
            },
            error => {
                setError(error.message)
                setErrorModal(true);
                // console.log(error.message);
            },
            () => {
                storage
                    .ref('bookbankfile')
                    .child(file.name)
                    .getDownloadURL()
                    .then(url => {
                        setFormData(prevValue => {
                            return {
                                ...prevValue,
                                bookbankfileurl: url,
                                bookbankfileurlloadfinish: "uploaded"
                            }
                        });
                        // console.log(url);
                    });
            })
        // console.log(event.target.files);
    }

    const handleValidSubmit = (event, values) => {
        event.preventDefault();
        const requestSubmitFormData = async () => {
            setIsLoading(true);
            try {
                const response = await axios.post('https://api.airtable.com/v0/app2DX8xVjOjR7O6y/USER-REGISTER-BASE',
                    JSON.stringify({
                        records: [
                            {
                                fields: {
                                    REGISTER_FIRSTNAME: formData.fname,
                                    REGISTER_LASTNAME: formData.lname,
                                    REGISTER_UNIT_GROUP: formData.unitgroup,
                                    REGISTER_NATIONAL_ID: formData.idcard.replace(/-/g, ""),
                                    NATIONAL_ID_FILE_NAME: formData.idcardfilename,
                                    NATIONAL_ID_FILE_ATTACH: [
                                        {
                                            url: formData.idcardfileurl
                                        }
                                    ],
                                    ADDRESS_DETAIL: formData.address,
                                    ADDRESS_SUB_DISTRICT: formData.districtSub,
                                    ADDRESS_DISTRICT: formData.district,
                                    ADDRESS_PROVINCE: formData.province,
                                    ADDRESS_ZIPCODE: formData.zipcode,
                                    REGISTER_NON_LIFE_INS_ID: formData.nonlifeinsidcard,
                                    NATIONAL_NON_LIFE_INS_ID_FILE_ATTACH: [
                                        {
                                            url: formData.brokerlicensefileurl
                                        }
                                    ],
                                    REGISTER_TEL_NUM: formData.tel.replace(/-/g, ""),
                                    REGISTER_EMAIL: formData.email,
                                    REGISTER_PASSWORD: formData.password,
                                    REGISTER_REMARK: formData.remark,
                                    AGENT_CODE: "ผู้แนะนำใหม่ยังไม่มีรหัส",
                                    REGISTER_BOOK_BANK_NUM: formData.bookBankNum.replace(/-/g, ""),
                                    REGISTER_BOOK_BANK_FILE: [
                                        {
                                            url: formData.bookbankfileurl
                                        }
                                    ],
                                    REGISTER_BANK_NAME: formData.bankName,
                                    REGISTER_BANK_BRANCH: formData.bankBranch,
                                    REGISTER_STATUS: "รอการตรวจสอบ"
                                }
                            }
                        ]
                    }),
                    {
                        headers: {
                            'Authorization': 'Bearer keyQZ2Z35zzGLXXMp',
                            'Content-Type': 'application/json'
                        }
                    });

                setResponseData(response.data.records[0])
                // console.log(response.data.records[0]);
                // console.log(responseData);
                // if (!response.ok) {
                //     throw new Error(responseData.message);
                // }
                setIsLoading(false);
                setSuccessModal(true);
            } catch (err) {
                setIsLoading(false);
                setError(err.message || 'Something went wrong, please try again.');
                setErrorModal(true);
            }
        }
        requestSubmitFormData()
    }

    // Manage errorModal upload or submit form
    const [errorModal, setErrorModal] = useState(false);
    const toggleErrorModal = () => {
        setErrorModal(!errorModal);
        setError(null);
    };

    // Manage successModal submit form
    const [successModal, setSuccessModal] = useState(false);
    const toggleSuccessModal = () => {
        setSuccessModal(!successModal);
        window.location.reload()
    };

    console.log(formData);
    // console.log(responseData);

    return (
        <React.Fragment>
            {error && !isLoading && (<div className="justify-content-center">
                <Modal isOpen={errorModal} toggle={toggleErrorModal} >
                    <ModalHeader toggle={toggleErrorModal}>ทำรายการไม่สำเร็จ</ModalHeader>
                    <ModalBody className="pb-2">
                        <p className="mb-2">เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง</p>
                        <p className="mb-2">{error}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="warning" onClick={toggleErrorModal}>ลองใหม่อีกครั้ง</Button>{' '}
                        {/* <Button color="danger" onClick={toggle}>Cancel</Button> */}
                    </ModalFooter>
                </Modal>
            </div>)}

            {responseData && !isLoading && (<div className="justify-content-center">
                <Modal isOpen={successModal}>
                    <ModalHeader toggle={toggleSuccessModal}>ลงทะเบียนสมาชิกสำเร็จ <i><FeatherIcon icon="check" className="fea icon-md icons text-success" /></i></ModalHeader>
                    <ModalBody className="pb-2">
                        <p className="mb-3 text-center h5">สรุปข้อมูลการลงทะเบียนทั้งหมดดังนี้</p>
                        <p className="mb-3 text-center h6">หมายเลขการลงทะเบียน: {responseData.fields.REGISTER_ID}</p>
                        <div className="row">
                            <div className="col-6 text-left">
                                <p className="mb-2 h6"> ชื่อ-นามสกุล</p>
                            </div>
                            <div className="col-6 text-right">
                                <p>{responseData.fields.REGISTER_FIRSTNAME} {responseData.fields.REGISTER_LASTNAME} </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6 text-left">
                                <p className="mb-2 h6"> หน่วยงาน</p>
                            </div>
                            <div className="col-6 text-right">
                                <p>{responseData.fields.REGISTER_UNIT_GROUP} </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-7 text-left">
                                <p className="mb-2 h6"> เลขที่บัตรประจำตัวประชาชน:</p>
                            </div>
                            <div className="col-5 text-right">
                                <p>{responseData.fields.REGISTER_NATIONAL_ID} </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-2 text-left">
                                <p className="mb-2 h6"> ที่อยู่</p>
                            </div>
                            <div className="col-10 text-right">
                                <p>{responseData.fields.ADDRESS_DETAIL}</p>
                            </div>
                            <div className="col-12 text-right">
                                <p>{responseData.fields.ADDRESS_SUB_DISTRICT} {responseData.fields.ADDRESS_DISTRICT} {responseData.fields.ADDRESS_PROVINCE} {responseData.fields.ADDRESS_ZIPCODE}</p>
                            </div>
                        </div>
                        {responseData.fields.REGISTER_NON_LIFE_INS_ID && <div className="row">
                            <div className="col-7 text-left">
                                <p className="mb-2 h6">เลขที่ใบอนุญาตเป็นนายหน้าวินาศภัย:</p>
                            </div>
                            <div className="col-5 text-right">
                                <p>{responseData.fields.REGISTER_NON_LIFE_INS_ID} </p>
                            </div>
                        </div>}
                        <div className="row">
                            <div className="col-6 text-left">
                                <p className="mb-2 h6"> เบอร์โทรศัพท์มือถือ:</p>
                            </div>
                            <div className="col-6 text-right">
                                <p>{responseData.fields.REGISTER_TEL_NUM} </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6 text-left">
                                <p className="mb-2 h6"> อีเมล:</p>
                            </div>
                            <div className="col-6 text-right">
                                <p>{responseData.fields.REGISTER_EMAIL} </p>
                            </div>
                        </div>
                        {responseData.fields.REGISTER_BOOK_BANK_NUM && <div className="row">
                            <div className="col-6 text-left">
                                <p className="mb-2 h6">เลขบัญชีธนาคาร:</p>
                            </div>
                            <div className="col-6 text-right">
                                <p>{responseData.fields.REGISTER_BOOK_BANK_NUM}</p>
                            </div>
                        </div>}
                        {responseData.fields.REGISTER_BANK_NAME && <div className="row">
                            <div className="col-6 text-left">
                                <p className="mb-2 h6">ชื่อธนาคาร:</p>
                            </div>
                            <div className="col-6 text-right">
                                <p>{responseData.fields.REGISTER_BANK_NAME}</p>
                            </div>
                        </div>}
                        {responseData.fields.REGISTER_BANK_BRANCH && <div className="row">
                            <div className="col-6 text-left">
                                <p className="mb-2 h6">สาขาธนาคาร:</p>
                            </div>
                            <div className="col-6 text-right">
                                <p>{responseData.fields.REGISTER_BANK_BRANCH}</p>
                            </div>
                        </div>}
                        {responseData.fields.REGISTER_REMARK && <div className="row">
                            <div className="col-2 text-left">
                                <p className="mb-2 h6"> หมายเหตุ:</p>
                            </div>
                            <div className="col-10 text-right">
                                <p>{responseData.fields.REGISTER_REMARK} </p>
                            </div>
                        </div>}
                        <div className="row">
                            <div className="col-5 text-left">
                                <p className="mb-2 h6"> รหัสผู้แนะนำ:</p>
                            </div>
                            <div className="col-7 text-right">
                                <p>{responseData.fields.AGENT_CODE} </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-5 text-left">
                                <p className="mb-2 h6"> สถานะการสมัคร:</p>
                            </div>
                            <div className="col-7 text-right">
                                <p>{responseData.fields.REGISTER_STATUS} </p>
                            </div>
                        </div>
                        <p className="mb-1 text-center h5">ขอขอบคุณที่ท่านสมัครใช้บริการ</p>
                        <p className="mb-3 text-center h5">TVinsure Web Application </p>
                        <p className="mb-3 text-left h6">รายละเอียดในขั้นตอนถัดไปมีดังต่อไปนี้</p>
                        <ul className="mt-1">
                            <li>รอการตรวจสอบและอนุมัติข้อมูลจากเจ้าหน้าที่ หากมีข้อผิดพลาดหรือข้อมูลไม่ครบทางเจ้าหน้าที่จะติดต่อกลับไป</li>
                            <li>เมื่ออนุมัติเสร็จสิ้น ระบบจะส่งข้อความยืนยันการสมัครให้กับสมาชิกผ่าน E-mail ตามที่ระบุไว้</li>
                            <li>สมาชิกสามารถ Login เข้าใช้งาน TVinsure Web App ได้ตามความต้องการ</li>
                        </ul>
                        {remarkid && remarkid === 'DT06052564' && <p className="my-3 text-center h6">รายละเอียดสำหรับกลุ่มไลน์รหัส {remarkid}</p>}
                        {remarkid && remarkid === 'DT06052564' && <img src={finGroupLine} className='d-block mx-auto' alt="FinGroupLine" height="150" />}
                        {remarkid && remarkid === 'DT06052564' && <a href="http://line.me/ti/g/AYmGjUZaOj" className="my-3 d-block text-center text-primary">หรือคลิกที่นี่เพื่อไปยังกลุ่มพูดคุยเลย</a>}

                        <p className="mt-4 mb-3">* หากเกิดข้อผิดพลาด หรือ มีข้อสงสัยในการสมัครสมาชิกสามารถติดต่อได้ตามช่องทางด้านล่าง</p>
                        <ul className="mt-1">
                            <li>Line: @tvinsure</li>
                            <li>โทรศัพท์: 0-2266-3731</li>
                        </ul>
                        <p className="text-left"># {responseData.id}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={toggleSuccessModal}>กลับสู่หน้าลงทะเบียน</Button>{' '}
                        {/* <Button color="danger" onClick={toggle}>Cancel</Button> */}
                    </ModalFooter>
                </Modal>
            </div>)}

            <section className="bg-auth bg-color">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={12}>
                            <Card>
                                <CardBody>
                                    <div className="text-center mb-3">
                                        <span>
                                            <img src={tvinsurelogo} alt="TVinsure" height="60" />
                                        </span>
                                    </div>
                                    <h4 className="text-center">ลงทะเบียนสมาชิกใหม่</h4>
                                    <h6 className="text-center">(ไม่เคยมีรหัสผู้แนะนำ)</h6>
                                    <p className="text-center">เพื่อเปิดรหัสผู้แนะนำและสมัครใช้ระบบ TVinsure Web App</p>
                                    <AvForm className="login-form mt-4" onValidSubmit={handleValidSubmit}>
                                        <Row>
                                            <Col md={4}>
                                                <FormGroup className="position-relative">
                                                    <Label>ชื่อ <span className="text-danger">*</span></Label>
                                                    <i><FeatherIcon icon="user" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="text" className="form-control pl-5"
                                                        errorMessage="กรุณากรอกชื่อ"
                                                        validate={{ required: { value: true } }} placeholder="ชื่อ" name="fname" onChange={handleChange} value={formData.fname} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup className="position-relative">
                                                    <Label>นามสกุล <span className="text-danger">*</span></Label>
                                                    <i><FeatherIcon icon="user-check" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="text" className="form-control pl-5"
                                                        errorMessage="กรุณากรอกนามสกุล"
                                                        validate={{ required: { value: true } }} placeholder="นามสกุล" name="lname" onChange={handleChange} value={formData.lname} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup className="position-relative">
                                                    <Label>หน่วยงาน <span className="text-danger">*</span></Label>
                                                    <i><FeatherIcon icon="align-center" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="text" className="form-control pl-5"
                                                        errorMessage="กรุณากรอกหน่วยงานในสังกัด"
                                                        validate={{ required: { value: true } }} placeholder="หน่วยงานในสังกัด" name="unitgroup" onChange={handleChange} value={formData.unitgroup} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>เลขบัตรประชาชน <span className="text-danger">*</span></Label>
                                                    <i><FeatherIcon icon="credit-card" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="text" className="form-control pl-5"
                                                        errorMessage="กรุณากรอกเลขบัตรประชาชนที่ถูกต้อง"
                                                        validate={{
                                                            required: { value: true },
                                                            pattern: { value: '^[0-9]-?[0-9][0-9][0-9][0-9]-?[0-9][0-9][0-9][0-9][0-9]-?[0-9][0-9]-?[0-9]$' }
                                                        }} placeholder="เลขบัตรประชาชน 13 หลัก" name="idcard" onChange={handleChange} value={formData.idcard} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>เลือกไฟล์บัตรประชาชน <span className="text-danger">*</span></Label>
                                                    <i><FeatherIcon icon="credit-card" className="fea icon-sm icons pt-1 pt-1" /></i>
                                                    {formData.idcardfileurlloadfinish === "uploading" && <small className="text-primary font-weight-bold"> กำลังอัพโหลด</small>}
                                                    {formData.idcardfileurlloadfinish === "uploaded" && <small className="text-success font-weight-bold"> อัพโหลดเสร็จสิ้น</small>}
                                                    <AvField type="file" className="form-control pl-5"
                                                        errorMessage="กรุณาแนบไฟล์บัตรประชาชน"
                                                        validate={{ required: { value: true } }} placeholder="ไฟล์บัตรประชาชน" name="idcardfile" onChange={fileSelectedHandler} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <FormGroup className="position-relative">
                                                    <Label>ที่อยู่ <span className="text-danger">*</span></Label>
                                                    <i><FeatherIcon icon="map" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="map" className="form-control pl-5"
                                                        errorMessage="กรุณากรอกที่อยู่"
                                                        validate={{ required: { value: true } }} placeholder="ที่อยู่ เช่น เลขที่บ้าน ชั้น ตึก ถนน ตรอก ซอย" name="address" onChange={handleChange} value={formData.address} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>จังหวัด <span className="text-danger" style={{ paddingLeft: "0" }}>*</span></Label>
                                                    <AvField type="select" className="form-control"
                                                        errorMessage="กรุณาเลือกจังหวัด"
                                                        validate={{ required: { value: true } }} placeholder="จังหวัด" name="province" onChange={handleChange} value={formData.province}>
                                                        <option value="" selected>จังหวัด</option>
                                                        {provinceData && provinceData.map(province => (<option value={province.PROV_NAME_T}>{province.PROV_NAME_T}</option>))}
                                                    </AvField>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>อำเภอ/เขต <span className="text-danger" style={{ paddingLeft: "0" }}>*</span></Label>
                                                    <AvField type="select" className="form-control"
                                                        errorMessage="กรุณาเลือกอำเภอ/เขต"
                                                        validate={{ required: { value: true } }} placeholder="อำเภอ/เขต" name="district" onChange={handleChange} value={formData.district}>
                                                        <option value="" selected>อำเภอ/เขต</option>
                                                        {districtData && districtData.map(district => (<option value={district.DISTRICT_NAME_T}>{district.DISTRICT_NAME_T}</option>))}
                                                    </AvField>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>ตำบล/แขวง <span className="text-danger" style={{ paddingLeft: "0" }}>*</span></Label>
                                                    <AvField type="select" className="form-control"
                                                        errorMessage="กรุณาเลือกตำบล/แขวง"
                                                        validate={{ required: { value: true } }} placeholder="ตำบล/แขวง" name="districtSub" onChange={handleChange} value={formData.districtSub}>
                                                        <option value="" selected>ตำบล/แขวง</option>
                                                        {districtSubFilter && districtSubFilter.map(districtSub => (<option value={districtSub.DISTRICT_NAME_T_SUB}>{districtSub.DISTRICT_NAME_T_SUB}</option>))}
                                                    </AvField>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>รหัสไปรษณีย์</Label>
                                                    <AvField type="text" className="form-control"
                                                        placeholder="รหัสไปรษณีย์" name="zipcode" value={formData.zipcode} disabled>{formData.zipcode}</AvField>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>เลขที่ใบอนุญาตเป็นนายหน้าประกันวินาศภัย (ถ้ามี)</Label>
                                                    <i><FeatherIcon icon="clipboard" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="text" className="form-control pl-5"
                                                        placeholder="เลขที่ใบอนุญาตเป็นนายหน้าประกันวินาศภัย" name="nonlifeinsidcard" onChange={handleChange} value={formData.nonlifeinsidcard} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>เลือกไฟล์ใบอนุญาตเป็นนายหน้าประกันวินาศภัย</Label>
                                                    <i><FeatherIcon icon="credit-card" className="fea icon-sm icons pt-1 pt-1" /></i>
                                                    {formData.brokerlicensefileurlloadfinish === "uploading" && <small className="text-primary font-weight-bold"> กำลังอัพโหลด</small>}
                                                    {formData.brokerlicensefileurlloadfinish === "uploaded" && <small className="text-success font-weight-bold"> อัพโหลดเสร็จสิ้น</small>}
                                                    <AvField type="file" className="form-control pl-5"
                                                        errorMessage="กรุณาแนบไฟล์ใบอนุญาตเป็นนายหน้าประกันวินาศภัย"
                                                        placeholder="ไฟล์ใบอนุญาตเป็นนายหน้าประกันวินาศภัย" name="brokerlicensefile" onChange={fileSelectedHandler} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>หมายเลขโทรศัพท์มือถือ <span className="text-danger">*</span></Label>
                                                    <i><FeatherIcon icon="smartphone" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="text" className="form-control pl-5"
                                                        errorMessage="กรุณากรอกหมายเลขโทรศัพท์มือถือที่ถูกต้อง"
                                                        validate={{
                                                            pattern: { value: '^[0][689][0-9]-?[0-9][0-9][0-9]-?[0-9][0-9][0-9][0-9]$' },
                                                        }} placeholder="หมายเลขโทรศัพท์มือถือ" name="tel" onChange={handleChange} value={formData.tel} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>อีเมล <span className="text-danger">*</span></Label>
                                                    <i><FeatherIcon icon="mail" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="email" className="form-control pl-5"
                                                        errorMessage="กรุณากรอกอีเมลที่ถูกต้อง"
                                                        validate={{
                                                            required: { value: true },
                                                            email: { value: true }
                                                        }} placeholder="อีเมล" name="email" onChange={handleChange} value={formData.email} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>รหัสผ่าน <span className="text-danger">*</span></Label>
                                                    <i><FeatherIcon icon="lock" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="password" className="form-control pl-5"
                                                        errorMessage="กรุณกรอกรหัสผ่าน 8-32 ตัวอักษร / ตัวเลขอย่างน้อย 1 ตัว / ตัวพิมพ์ใหญ่อย่างน้อย 1 ตัว / ตัวพิมพ์เล็กอย่างน้อย 1 ตัว"
                                                        validate={{
                                                            minLength: { value: 8 },
                                                            maxLength: { value: 32 },
                                                            pattern: { value: '(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])' }
                                                        }} name="password" placeholder="รหัสผ่าน 8-32 ตัวอักษร ตัวเลข ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก" onChange={handleChange} value={formData.password} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>ยืนยันรหัสผ่าน <span className="text-danger">*</span></Label>
                                                    <i><FeatherIcon icon="lock" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="password" className="form-control pl-5"
                                                        errorMessage="กรุณากรอกรหัสผ่านให้ตรงกัน"
                                                        validate={{
                                                            required: { value: true },
                                                            match: { value: "password" }
                                                        }} name="repassword" placeholder="ยืนยันรหัสผ่าน" onChange={handleChange} value={formData.repassword} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>เลขบัญชีธนาคาร <span className="text-danger">*</span></Label>
                                                    <i><FeatherIcon icon="align-center" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="text" className="form-control pl-5"
                                                        errorMessage="กรุณากรอกเลขบัญชีธนาคาร"
                                                        placeholder="หมายเลขบัญชีธนาคารที่ท่านต้องการให้เราจ่ายผลประโยชน์คืนให้"
                                                        validate={{
                                                            required: { value: true }
                                                        }}
                                                        name="bookBankNum"
                                                        onChange={handleChange}
                                                        value={formData.bookBankNum} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>เลือกไฟล์หน้าสมุดบัญชีธนาคาร <span className="text-danger">*</span></Label>
                                                    <i><FeatherIcon icon="credit-card" className="fea icon-sm icons pt-1 pt-1" /></i>
                                                    {formData.bookbankfileurlloadfinish === "uploading" && <small className="text-primary font-weight-bold"> กำลังอัพโหลด</small>}
                                                    {formData.bookbankfileurlloadfinish === "uploaded" && <small className="text-success font-weight-bold"> อัพโหลดเสร็จสิ้น</small>}
                                                    <AvField type="file" className="form-control pl-5"
                                                        errorMessage="กรุณาแนบไฟล์หน้าสมุดบัญชีธนาคาร"
                                                        validate={{ required: { value: true } }} placeholder="ไฟล์หน้าสมุดบัญชีธนาคาร" name="bookbankfile" onChange={fileSelectedHandler} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>ชื่อธนาคาร</Label>
                                                    <i><FeatherIcon icon="align-center" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="text" className="form-control pl-5"
                                                        placeholder="ชื่อธนาคาร เช่น กรุงศรี BAY .... "
                                                        name="bankName"
                                                        onChange={handleChange}
                                                        value={formData.bankName} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup className="position-relative">
                                                    <Label>ชื่อสาขา</Label>
                                                    <i><FeatherIcon icon="align-center" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="text" className="form-control pl-5"
                                                        placeholder="ชื่อสาขา เช่น สาขาสีลม"
                                                        name="bankBranch"
                                                        onChange={handleChange}
                                                        value={formData.bankBranch} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <FormGroup className="position-relative">
                                                    <Label>หมายเหตุ</Label>
                                                    <i><FeatherIcon icon="align-center" className="fea icon-sm icons pt-1" /></i>
                                                    <AvField type="text" className="form-control pl-5"
                                                        placeholder="หมายเหตุอื่น ๆ เช่น หน่วยงานที่สังกัด"
                                                        name="remark"
                                                        onChange={handleChange}
                                                        value={formData.remark}
                                                        disabled
                                                    />
                                                </FormGroup>
                                            </Col>
                                            {/* <Col md={12}>
                                                <FormGroup>
                                                    <div className="custom-control custom-checkbox">
                                                        <Input type="checkbox" className="custom-control-input" id="customCheck1" />
                                                        <Label className="custom-control-label" htmlFor="customCheck1">I Accept <Link to="#" className="text-warning">Terms And Condition</Link></Label>
                                                    </div>
                                                </FormGroup>
                                            </Col> */}
                                            <Col lg={12} className="mb-0 auth-button">
                                                {!isLoading && <Button color="warning" block disabled={formData.idcardfileurlloadfinish !== "uploaded" || formData.bookbankfileurlloadfinish !== "uploaded"}>ลงทะเบียน</Button>}
                                                {isLoading && <Button color="warning" block disabled >กำลังลงทะเบียน</Button>}
                                            </Col>
                                            <Col lg={12} className="text-center">
                                                <p className="mb-0 mt-3"><small className="text-dark mr-2 h6 mt-2">ย้อนกลับ...</small><Link to="/" className="font-weight-bold h5 text-warning">หน้าลงทะเบียน</Link></p>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

        </React.Fragment>
    );
}


export default PageSignupWithOutCode;